export const PROFILE_DATA = "PROFILE_DATA"
export const PROFILEDATA_ERROR = " PROFILEDATA_ERROR"
export const PROFILEDATA_RESET = "PROFILEDATA_RESET"

export const PROFILE_COMPLETION_START = "PROFILE_COMPLETION_START";
export const PROFILE_COMPLETION_SUCCESS = "PROFILE_COMPLETION_SUCCESS"
export const PROFILECOMPLETION_ERROR = " PROFILECOMPLETION_ERROR"
export const PROFILECOMPLETION_RESET = "PROFILECOMPLETION_RESET"